export const associateRepertiJson = [
  {
    label: "Cassetta",
    attr: "cassetta",
    index: 0,
    value: null,
  },
  {
    label: "Tipo",
    attr: "tipo",
    index: 0,
    value: null,
  },
  {
    label: "Note",
    attr: "note",
    index: 0,
    value: null,
  },
  {
    label: "Materia",
    attr: "materia",
    index: 0,
    value: null,
  },
  {
    label: "Forma",
    attr: "forma",
    index: 0,
    value: null,
  },
  {
    label: "Confronti",
    attr: "confronti",
    index: 0,
    value: null,
  },
  {
    label: "Classe",
    attr: "classe",
    index: 0,
    value: null,
  },
  {
    label: "Anno di scavo",
    attr: "anno",
    index: 0,
    value: null,
  },
];

export const tipoJson = [
  { label: "ambiente", value: "ambienti" },
  { label: "insula", value: "insulae" },
  { label: "quadrato", value: "quadrati" },
  { label: "saggio", value: "saggi" },
  { label: "scavo", value: "scavi" },
  { label: "settore", value: "settori" },
  { label: "sito", value: "siti" },
  { label: "strada", value: "strade" }, 
  { label: "strato", value: "strati" },
  { label: "taglio", value: "tagli" },
  { label: "trincea", value: "trincee" }
];


